import React from 'react';
import GenerationStatus from './GenerationStatus';

interface GenerationProps {
  text: string;
  status: string;
  className?: string;
  isPlus?: boolean;
}

const Generation: React.FC<GenerationProps> = ({
  text,
  className,
  status,
  isPlus,
}) => {
  return (
    <div className={`${className} flex items-center`}>
      <span className="pop-18-semibold leading-none">{text}</span>
      {status && (
        <GenerationStatus
          className="ml-[7px]"
          text={status}
          isPlus={isPlus}
        ></GenerationStatus>
      )}
    </div>
  );
};

export default Generation;
